//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.1.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum CustomTranslationType {
    Master = 0,
    Custom = 1,
    Conflict = 2,
}

export interface QuizOptionVm {
    id: number;
    guid: string | null;
    customTranslation: CustomTranslationType;
    title: string | null;
    text: string | null;
    resolution: string | null;
    isRight: boolean;
    contentUrl: string | null;
    fillContainer: boolean;
    horizontalAlign: string | null;
    prompt: string | null;
    changePrompt: string | null;
    altText: string | null;
    imageLibrarySearchText: string | null;
}

export interface CourseElementVm {
    id: number;
    guid: string | null;
    type: string | null;
    textCustomTranslation: CustomTranslationType;
    contentUrlCustomTranslation: CustomTranslationType;
    altTextCustomTranslation: CustomTranslationType;
    titleCustomTranslation: CustomTranslationType;
    leftLabelCustomTranslation: CustomTranslationType;
    rightLabelCustomTranslation: CustomTranslationType;
    title: string | null;
    text: string | null;
    imageLibrarySearchText: string | null;
    changePrompt: string | null;
    contentUrl: string | null;
    invisible: boolean;
    file: string | null;
    aiSummary: string | null;
    width: string | null;
    height: string | null;
    alignment: string | null;
    textAlign: string | null;
    transparentGradient: boolean;
    darkMode: string | null;
    color: string | null;
    size: string | null;
    weight: string | null;
    fontStyle: string | null;
    aspectRatio: string | null;
    fillContainer: boolean;
    imagePosition: string | null;
    createdWithAi: boolean;
    altText: string | null;
    style: string | null;
    enableZoom: boolean;
    enableScore: boolean;
    closed: boolean;
    enableDownload: boolean;
    enablePrint: boolean;
    hideText: boolean;
    dense: boolean;
    pitch: number;
    rate: number;
    preventSeeking: boolean;
    playOnLoad: boolean;
    min: number;
    max: number;
    preset: number;
    leftLabel: string | null;
    rightLabel: string | null;
    showAnswer: boolean;
    showCorrectAnswer: boolean;
    showManuelApprovalComment: boolean;
    compSettings: string | null;
    options: QuizOptionVm[] | null;
    children: CourseElementVm[] | null;
}